/* 🤖 this file was generated by svg-to-ts */
export const iconBat: {
  name: 'bat';
  data: string;
} = {
  name: 'bat',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><path fill="currentColor" d="M29.82 7.92a16.16 16.16 0 0 0-5.75-5.75A15.75 15.75 0 0 0 16.01 0c-2.88 0-5.59.73-8.09 2.17a16.16 16.16 0 0 0-5.75 5.75C.72 10.41 0 13.11 0 15.99s.73 5.58 2.17 8.07c1.43 2.41 3.35 4.33 5.75 5.75 2.49 1.45 5.19 2.17 8.07 2.17s5.58-.73 8.07-2.17c2.41-1.43 4.33-3.35 5.75-5.75 1.45-2.49 2.17-5.19 2.17-8.07s-.73-5.58-2.17-8.07zM15.37 5.07v7l-3.64 6.39-6.07 3.48 9.72-16.88zm-9.14 17.9 6.04-3.52h7.45l6.04 3.52zm14-4.5-3.74-6.39v-7l9.78 16.88-6.04-3.48z"/></svg>`,
};
